<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <div class="Productcenter">
            <div class="pagestitle clearfix">
                    <span class="pageslink"><router-link class="indexicon" to="/" />&nbsp;<a class="cur" href="javascript:;">网站地图</a>

                    </span>
              <h4>
                <span>网站地图</span>

              </h4>
            </div>
          </div>

          <div class="mainbody">
            <div class="webmap02">
              <div v-for="(item,index) in menus" :key="index">
                <h3 class="clearfix"><span><router-link :to="item.src">{{item.name}}</router-link></span><em></em></h3>
                <p> <router-link v-for="(c,i) in item.children" :key="i" :to="c.src">{{c.name}}</router-link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Banner from '@/views/us/componets/Banner'
export default {
  components: { Banner },
  data () {
    return {
      menus: []
    }
  },
  mounted () {
    axios({
      method: 'get',
      url: process.env.API_ROOT + 'static/menu.json'
    })
      .then(response => {
        this.menus = response.data
      }).catch(reason => {
        console.log(reason)
      })
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/us/webmap.vue